<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-total-points">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4 pointsContiner">
            <div class="row">
              <div class="col-sm-4 col-md-4">
                <h6><router-link :to="{ name: 'Bulletin' }"> Bulletins </router-link></h6>
              </div>
            </div>
            <div>
              <div>
                <h8> Edit Bulletin</h8>
              </div>
              <a-collapse v-model="activeKey" class=""
                ><a-collapse-panel key="1" header="Basic Settings">
                  <div>
                    <label>Client:</label>
                    <a-select mode="multiple" style="width: 80%" placeholder="Please select client">
                      <a-select-option key="1"> Divy </a-select-option>
                    </a-select>
                  </div>
                  <div><label>Name:</label> <a-input style="width: 80%" placeholder="Please Enter Name" /></div>
                </a-collapse-panel>
                <a-collapse-panel key="2" header="Style Settings">
                  Background Colour:
                  <a-select style="width: 80%" placeholder="Please select colour">
                    <a-select-option key="1"> Red </a-select-option>
                  </a-select></a-collapse-panel
                >
                <a-collapse-panel key="3" header="Bulletin">
                  <label>Body:</label
                  ><a-textarea placeholder="Please Enter Body" style="width: 80%" :auto-size="{ minRows: 3, maxRows: 5 }" /> </a-collapse-panel
              ></a-collapse>
            </div>
            <hr />
            {{ (activeMenuItem, activeMenu) }}
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';

export default {
  name: 'TotalPoints',

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  data() {
    return {
      data: [],
      activeKey: ['1', '2', '3'],
    };
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'communicationBulletin',
        activeMenu: this.activeMenu ? this.activeMenu : 'communication',
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.admin-user-total-points {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.select-width {
  width: 50%;
}

.align-right {
  text-align: right;
}

.total-points {
  font-weight: bold;
  text-align: right;
}
.pointsContiner {
  margin-top: 5%;
}
label {
  width: 150px;
}
.ant-collapse-content.ant-collapse-content-active {
  div {
    margin-bottom: 2%;
  }
}
</style>
